import React from 'react'

import { Typography } from '@material-ui/core'
import { useTranslate } from 'react-admin'

import { ADVANCE_LIST_STEP, FILE_UPLOAD_STEP } from './createDialogConstants'
import useStyles from './styles'

export const CreateInvoiceDialogTitle = ({
  isFinished,
  stepNumber,
  errorSave,
  invoiceList,
}) => {
  const classes = useStyles()
  const translate = useTranslate()

  if (stepNumber === FILE_UPLOAD_STEP) {
    return (
      <Typography className={classes.title}>
        {translate('resources.invoices.actions.create.upload.title')}
      </Typography>
    )
  }

  if (stepNumber === ADVANCE_LIST_STEP && (!isFinished || errorSave)) {
    return (
      <>
        <Typography className={classes.title}>
          {translate('resources.invoices.actions.create.summary.title')}
        </Typography>
        <Typography className={classes.subtitle}>
          {translate('resources.invoices.actions.create.summary.subtitle')}:{' '}
          <strong>{invoiceList?.length ?? 0}</strong>
        </Typography>
      </>
    )
  }

  if (stepNumber === ADVANCE_LIST_STEP && isFinished && !errorSave) {
    return (
      <Typography className={classes.title}>
        {translate('resources.invoices.actions.create.response.title')}
      </Typography>
    )
  }

  return (
    <>
      <Typography className={classes.title}>
        {translate('resources.invoices.actions.create.request.title')}
      </Typography>
      <Typography className={classes.subtitle}>
        {translate('resources.invoices.actions.create.request.subtitle')}
      </Typography>
    </>
  )
}
